import React from 'react'

const NotFound = () => {
  return (
    <h1>404. Nothing found</h1>
  )
}

export default NotFound